import React from "react";
import { withSentryTracing } from "supercell-frontend-base/src/tracing/sentry";
import { AppController } from "./controller";
import { SnowplowContextProvider } from "supercell-frontend-base/src/analytics/snowplow";
import { BoomBeachGameParams } from "../../validation/game-params";
import {
    GameParamsContextProvider,
    DEFAULT_STATE,
} from "supercell-frontend-base/src/stores/gameParams";

const WithGameParams = (props) => {
    return (
        <SnowplowContextProvider
            config={{
                appId: window.SNOWPLOW_APP_ID,
                collectorUrl: window.SNOWPLOW_COLLECTOR_URL,
            }}
        >
            <GameParamsContextProvider<BoomBeachGameParams>
                initialState={DEFAULT_STATE}
                gameParamsParser={BoomBeachGameParams}
            >
                <AppController {...props} />
            </GameParamsContextProvider>
        </SnowplowContextProvider>
    );
};

export const App = withSentryTracing(WithGameParams);
